import { render, staticRenderFns } from "./company-address.vue?vue&type=template&id=3ac199c9"
import script from "./company-address.vue?vue&type=script&lang=ts"
export * from "./company-address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/vercel/path0/components/ui/input.vue').default})
